import * as T from 'io-ts';
const RequiredUserClaimsT = T.type({ organization: T.string });
const OptionalUserClaimsT = T.partial({ role: T.literal('Admin') });
export const UserClaimsT = T.intersection([RequiredUserClaimsT, OptionalUserClaimsT]);
